import { SITE } from "@/data/site";
import { Phone } from "lucide-react";

export const MobileCallBar = () => {
  return (
    <a
      href={SITE.phoneHref}
      data-testid="mobile-call-bar"
      className="fixed bottom-0 left-0 right-0 z-[150] lg:hidden flex items-center justify-center gap-2.5"
      style={{
        background: "var(--gold-gradient)",
        color: "var(--black)",
        fontWeight: 700,
        fontSize: "16px",
        letterSpacing: "0.02em",
        padding: "15px 16px",
        boxShadow: "0 -6px 20px rgba(0,0,0,0.25)",
      }}
    >
      <Phone size={19} strokeWidth={2} />
      Call {SITE.phone}
    </a>
  );
};
